<script>
  import { gsap } from "gsap";
  import { ScrollTrigger } from "gsap/ScrollTrigger";
  import Intro from "./Intro.svelte";
  import InfoBlock from "./InfoBlock.svelte";
  import Carousel from "./Carousel.svelte";
  import Lateral from "./Lateral.svelte";
  import LateralImages from "./LateralImages.svelte";
  import Resistance from "./Resistance.svelte";
  import Characteristics from "./Characteristics.svelte";
  import PhotosLight from "./PhotosLight.svelte";
  import PhotosDark from "./PhotosDark.svelte";

  const imageIntroLight = "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/shoe_intro_light.png";
  const imageIntroDark = "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/shoe_intro_dark.png";
  const carouselLightItem1Image = "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/carousel_light_item_1.png";
  const carouselLightItem2Image = "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/carousel_light_item_2.png";
  const carouselDarkItem1Image = "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/carousel_dark_item_1.png";
  const carouselDarkItem2Image = "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/carousel_dark_item_2.png";
  const shoeLateralLightImage = "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/shoe_lateral_light.png";
  const shoeLateralDarkImage = "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/shoe_lateral_dark.png";
  const shoeZoomLightImage = "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/shoe-zoom-light.png";
  const shoeZoomDarkImage = "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/shoe-zoom-dark.png";
  const backgroundCharacteristicsLight =
    "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/background_characteristics_light.png";
  const backgroundCharacteristicsDark =
    "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/background_characteristics_dark.png";

  const iconMaintien =
    "data:img/png;base64,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";
  const iconDynamisme =
    "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAAA0CAYAAAAkEw66AAAE80lEQVRoge3baYiVVRzH8Y/OqGiYjbaYZRFpkSaVRUHaImJhm5oUbZS0Y2960UJgWRBEWZkltNBGZlGUEZaGtllKi0rSRslYZgptplIOuWUv/jM23Ln3eZ67OHOv4/eN8PzPuec8P89zzn8506VfQ4NOzOl4GMOxEY/jHmxN69ilEws3DMvQPef5e5iITUmdu+6mSdUCk7UVDUZjMQYmde7Mwh2YYDsWn+K4Qg06s3CfpdgH4COclc9Y16tnz4rPqEb4AmNwSEKbHrgEa7GitaEzC7cNr4gTdVBCuzqMQxcs2vWwEwrXHf1xOI7AdzgVfVL6ndncZz527MnuSDexmk7GURiMo3GY8vb2hRi/JwlXhxEY2/zvSdhdn9OTtS5cvTj1JuJ8HNBO426ub6eBKs1AXIPrcXAHjN+j1oQ7HneKU66uA+cxr1aEG4K7cLFwCzqSlZhc7cI14F7cqPwoZztWixdfhz+wvnmM28QpnMY7uAwbqlm4KzFNckyZxA8iZFqC5fhG23TRBXhRNtHuE9vEDuJUqjb2xzPipYphpxDpNbyNxpT24zBH+kpuwtUiythFtQk3GrMUd1Kuw9N4Dj8V0W+adNFWC4G/zDVUk3C34H7Z97IV4uVfFftXsQxOsb8vDqP1+YythRuAq3AovhL/85tLmFCxdMdTzWNnYSWmiE9yZxnj/ihi1XxMx62a97N8tEQOJwiF92tlWyVeZkkZk0ujF97CqAxtN2MqHpOhJpCBS/FSzrN/hFM9K61zS3bkdW2Xbl9MEhP+pNxZ5qGPCJhPy9B2Ic4W7kDBVVAkX2OpOLW34UNcjnezdG5Zcf9Kdiyfx7UqN+k+WCAyF0lsxe2YobzPsuK0bMR/prSbJFZlJbINPfGmdNHWYiQeUWWi8b9wMzK0bfF78lWGslKHl3FGSrvlIi20tIyxdiste9zHQsSRkt2BQThGCFjKKnhAOJNJzMc52FDC77cbrVPnH4iTdSx6J/QZIhzUuUWOdQUeTGkzFxeK062qya05rBEO5RjJMeKJ4spAWomthWHC7UhyuBdggsq4GrudQhngLKfeduF/LU4Zo6e4ajAkoc3S5t9qD4e7IhTazzaJlPTnCX3rReDbN2WM6ZJFa8S5akg0kg+CTWKT/j6hzQA8kWAfhRsS7E1iT/s9oU1VkhZQr8d5kv28i8TL59JLpIeSuE7ExTVHlkxEozgRk5iJfXOeTVE4iCYC+9xYsWbIWslvFCtoRAF7b+HctsR5R2K2wgWV1RivRk7QfBRTV+0hPPqhBezbhHO8SjjIEwq02yn2vkUF7DVBMQWQLaKWWShi6CZy8qcoLBqRqa1p0Sj+0s06kegcXsA+TAjXv4B9o/hEa8r1yEcpJbc7FH7xOgm3GHE3fithzKqjlGteTWK/S8tw5PKzKPlVKqfXoZRa5J2Ov4rsM1UNn6K5lCrcRuGHZWWNDHn8WqKcawWPipR7Fh5SWgmvailHuDWieJLGJjxbxjhVSbkXWbII8gL+LnOcqqPcG5k9RGYjKWM8FN+WM0g1Uu6K24J5CfZl9kDRqMxf1ryRYJtdgd+vSupFIXqMCNBLue1YLypSud98E/bBzeVMsIPZKK6MtUm0dunX0DATN7X7lGqHX8Xd419aP+wqObW9Fw6SJ9vTVSi6l2TafKpdxVWu1e0+ldqgSfy5+Zxcw3/FsuSLjMjvOwAAAABJRU5ErkJggg==";

  export let name;

  let carouselLight;
  let carouselDark;

  const handleCarouselClickFromLight = () => {
    carouselDark.activateCarousel();
  };
  const handleCarouselClickFromDark = () => {
    carouselLight.activateCarousel();
  };
</script>

<main class="app">
  <div class="app__container">
    <div class="app__cols">
      <div class="app__background app__background--light">&nbsp;</div>
      <div class="app__background app__background--dark">&nbsp;</div>
      <div class="app__intro--light">
        <Intro
          title={"TS990"}
          subtitle={"Résistance & dynamisme"}
          pictureUrl={imageIntroLight}
          carouselItem1Image={carouselLightItem1Image}
          carouselItem2Image={carouselLightItem2Image}
        />
      </div>
      <div class="app__info-block app__info-block--light">
        <InfoBlock
          title={"Pure speed"}
          text={"Légères. Les TS990 sont équipées du concept Pebax Powered qui optimise le dynamisme et la relance de votre course. La technologie exclusive Lateral CS complète la chaussure et propose un amorti ultra performant. Vous ne serez jamais pris de vitesse."}
        />
      </div>
      <div class="app__carousel--light">
        <Carousel
          item1Url={carouselLightItem1Image}
          item2Url={carouselLightItem2Image}
          backgroundText={"990"}
          on:carousel-click={handleCarouselClickFromLight}
          bind:carousel={carouselLight}
        />
      </div>
      <div class="app__intro--dark">
        <Intro
          title={"TS960"}
          subtitle={"Résistance & Maintien"}
          pictureUrl={imageIntroDark}
          carouselItem1Image={carouselDarkItem1Image}
          carouselItem2Image={carouselDarkItem2Image}
          dark
        />
      </div>
      <div class="app__info-block app__info-block--dark">
        <InfoBlock
          title={"Optimal support"}
          text={"Les TS960 sont dotées du concept exclusif Lateral CS qui apporte sécurité et confort, du système Arkstab qui assure une stabilité performante et d'une tige renforcée pour un maintien optimal. Laissez votre empreinte sur le court !"}
          dark
        />
      </div>
      <div class="app__carousel--dark">
        <Carousel
          item1Url={carouselDarkItem1Image}
          item2Url={carouselDarkItem2Image}
          backgroundText={"960"}
          on:carousel-click={handleCarouselClickFromDark}
          bind:carousel={carouselDark}
          dark
        />
      </div>
      <div class="app__title-lateral--full">
        <Lateral full />
      </div>
      <div class="app__title-lateral--light">
        <Lateral light />
      </div>
      <div class="app__title-lateral--dark">
        <Lateral dark />
      </div>
      <div class="app__image-lateral--light">
        <LateralImages
          backgroundImage={shoeLateralLightImage}
          zoomImage={shoeZoomLightImage}
        />
      </div>
      <div class="app__image-lateral--dark">
        <LateralImages
          backgroundImage={shoeLateralDarkImage}
          zoomImage={shoeZoomDarkImage}
          dark
        />
      </div>
      <div class="app__resistance--full">
        <Resistance full />
      </div>
      <div class="app__resistance--light">
        <Resistance light />
      </div>
      <div class="app__resistance--dark">
        <Resistance dark />
      </div>
      <div class="app__characteristics--light">
        <Characteristics
          title={"Lateral CS"}
          text={"Les impacts au sol au tennis sont tels, qu'Artengo et Decathlon SportLab ont développé ce concept exclusif. Constitué de PU (polyuréthane) inséré sous le talon au niveau des zones d'appuis, il réduit de 13% la force d'impact au sol. Engagez vous sans risque dans vos frappes !"}
          textOffset={"80%"}
          title2={"Zones KPU"}
          text2={"Placé aux zones de frottements et d'usures extrêmes, le KPU apporte la touche de résistance supplémentaire à vos nombreux déplacements."}
          textOffset2={"70%"}
          title3={"Pebax Powered"}
          text3={"Développé par Arkema, le Pebax Powered est un polymère très léger. Placé au centre sous la chaussure, il restitue de manière performante et optimale l'énergie liée à sa torsion lors d'un appui. C'est une véritable force pour aciliter votre déplacement."}
          textOffset3={"50%"}
          title4={"Rublast"}
          text4={"Caoutchouc utilisé pour la semelle. Ultra-résistant et soumis aux tests d'abrasion en laboratoire, il garantit une excellente durabilité des TS990. A vous les 5èmes sets !"}
          textOffset4={"30%"}
          image={backgroundCharacteristicsLight}
        />
      </div>
      <div class="app__characteristics--dark">
        <Characteristics
          title={"Lateral CS"}
          text={"Les impacts au sol au tennis sont tels, qu'Artengo et Decathlon SportLab ont développé ce concept exclusif. Constitué de PU (polyuréthane) inséré sous le talon au niveau des zones d'appuis, il réduit de 13% la force d'impact au sol. Engagez vous sans risque dans vos frappes !"}
          textOffset={"30%"}
          title2={"Zones KPU"}
          text2={"Placé aux zones de frottements et d'usures extrêmes, le KPU apporte la touche de résistance supplémentaire à vos nombreux déplacements."}
          textOffset2={"90%"}
          title3={"Arkstab"}
          text3={"Pièce en Pebax située au centre sous la chaussure qui garantit un maintien optimal au sol. L'élément agit également sur la performance du support de la tige de la chaussure."}
          textOffset3={"50%"}
          title4={"Rublast"}
          text4={"Caoutchouc utilisé pour la semelle. Ultra-résistant et soumis aux tests d'abrasion en laboratoire, il garantit une excellente durabilité des TS960. A vous les 5èmes sets !"}
          textOffset4={"20%"}
          image={backgroundCharacteristicsDark}
          dark
        />
      </div>
      <div class="app__photos--light">
        <PhotosLight />
      </div>
      <div class="app__photos--dark">
        <PhotosDark />
      </div>
    </div>
  </div>
</main>

<style lang="scss">
  @import "./assets/styles/variables";

  .app {
    min-height: 200vh;
    max-width: 100vw;

    @media screen and (min-width: $breakpoint-medium) {
      background-image: linear-gradient(
        90deg,
        $background-color-left-start 0%,
        $background-color-left-end 50%,
        $background-color-right-start 50%,
        $background-color-right-end 100%
      );
    }

    &__container {
      margin: 0 auto;
      width: 100vw;

      @media screen and (min-width: $breakpoint-medium) {
        max-width: 1280px;
        width: auto;
      }
    }

    &__background {
      height: 100%;
      width: 100%;

      &--light {
        background-image: linear-gradient(
          90deg,
          $background-color-left-start 0%,
          $background-color-left-end 100%
        );
        grid-column: 1 / span 1;
        grid-row: 1 / span 11;
      }

      &--dark {
        background-image: linear-gradient(
          90deg,
          $background-color-right-start 0%,
          $background-color-right-end 100%
        );
        grid-column: 1 / span 1;
        grid-row: 12 / span 11;
      }

      @media screen and (min-width: $breakpoint-medium) {
        display: none;
      }
    }

    &__intro {
      &--light {
        grid-column: 1 / span 1;
        grid-row: 1 / span 1;
      }

      &--dark {
        grid-column: 1 / span 1;
        grid-row: 12 / span 1;
      }
    }

    &__info-block {
      padding-top: 2rem;

      &--light {
        grid-column: 1 / span 1;
        grid-row: 2 / span 1;
      }

      &--dark {
        grid-column: 1 / span 1;
        grid-row: 13 / span 1;
      }
    }

    &__carousel {
      &--light {
        grid-column: 1 / span 1;
        grid-row: 3 / span 1;
      }

      &--dark {
        grid-column: 1 / span 1;
        grid-row: 14 / span 1;
      }
    }

    &__title {
      &-lateral--full {
        display: none;
      }

      &-lateral--light {
        grid-column: 1 / span 1;
        grid-row: 4 / span 1;
      }

      &-lateral--dark {
        grid-column: 1 / span 1;
        grid-row: 15 / span 1;
      }
    }

    &__image {
      &-lateral--light {
        grid-column: 1 / span 1;
        grid-row: 5 / span 1;
      }

      &-lateral--dark {
        grid-column: 1 / span 1;
        grid-row: 16 / span 1;
      }
    }

    &__resistance {
      &--full {
        display: none;
      }

      &--light {
        grid-column: 1 / span 1;
        grid-row: 6 / span 1;
      }

      &--dark {
        grid-column: 1 / span 1;
        grid-row: 17 / span 1;
      }
    }

    &__characteristics {
      &--light {
        grid-column: 1 / span 1;
        grid-row: 7 / span 1;
      }

      &--dark {
        grid-column: 1 / span 1;
        grid-row: 18 / span 1;
      }
    }

    &__photos {
      &--light {
        grid-column: 1 / span 1;
        grid-row: 9 / span 1;
      }

      &--dark {
        grid-column: 1 / span 1;
        grid-row: 19 / span 1;
      }
    }

    @media screen and (min-width: $breakpoint-medium) {
      &__intro {
        &--light {
          grid-column: 1 / span 1;
          grid-row: 1 / span 1;
        }

        &--dark {
          grid-column: 2 / span 1;
          grid-row: 1 / span 1;
        }
      }

      &__info-block {
        &--light {
          grid-column: 1 / span 1;
          grid-row: 2 / span 1;
        }

        &--dark {
          grid-column: 2 / span 1;
          grid-row: 2 / span 1;
        }
      }

      &__carousel {
        &--light {
          grid-column: 1 / span 1;
          grid-row: 3 / span 1;
        }

        &--dark {
          grid-column: 2 / span 1;
          grid-row: 3 / span 1;
        }
      }

      &__title {
        &-lateral--full {
          display: block;
          grid-column: 1 / span 2;
          grid-row: 4 / span 1;
        }

        &-lateral--light {
          display: none;
        }

        &-lateral--dark {
          display: none;
        }
      }

      &__image {
        &-lateral--light {
          grid-column: 1 / span 1;
          grid-row: 5 / span 1;
        }

        &-lateral--dark {
          grid-column: 2 / span 1;
          grid-row: 5 / span 1;
        }
      }

      &__resistance {
        &--full {
          display: block;
          grid-column: 1 / span 2;
          grid-row: 6 / span 1;
        }

        &--light {
          display: none;
        }

        &--dark {
          display: none;
        }
      }

      &__characteristics {
        &--light {
          grid-column: 1 / span 1;
          grid-row: 7 / span 1;
        }

        &--dark {
          grid-column: 2 / span 1;
          grid-row: 7 / span 1;
        }
      }

      &__photos {
        &--light {
          grid-column: 1 / span 1;
          grid-row: 8 / span 1;
        }

        &--dark {
          grid-column: 2 / span 1;
          grid-row: 8 / span 1;
        }
      }
    }

    &__cols {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: repeat(17, auto);
      grid-column-gap: 0px;
      grid-row-gap: 0px;
      max-width: 100vw;

      @media screen and (min-width: $breakpoint-medium) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(5, auto);
        grid-column-gap: 0px;
        grid-row-gap: 0px;
      }
    }
  }
</style>
